import React from 'react';
import { styled } from 'baseui';
import { SIZE, Spinner } from 'baseui/spinner';
import FrameFetcher from '../frame-fetcher/frame-fetcher';
import { FRAME_CONTROL_MODE } from './constants';
type FrameControlPanelLayoutPropsT = {
  frameControls: React.ReactNode;
  annotationTimeline: React.ReactNode;
  mode: (typeof FRAME_CONTROL_MODE)[keyof typeof FRAME_CONTROL_MODE];
  isFramesLoading: boolean;
  setImageLoadStatus: (index: number) => void;
};
const Container = styled('div', () => ({
  display: 'flex',
  flexWrap: 'wrap',
  alignSelf: 'start',
  width: '100%'
}));
const SpinnerWrapper = styled('div', ({
  $theme
}) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  padding: $theme.sizing.scale100
}));
export const FrameControlPanelLayout = ({
  frameControls,
  annotationTimeline,
  mode,
  isFramesLoading,
  setImageLoadStatus
}: FrameControlPanelLayoutPropsT) => {
  if (mode === FRAME_CONTROL_MODE.COMPACT) {
    return <Container>{frameControls}</Container>;
  }
  return <Container>
      {frameControls}

      {isFramesLoading ? <SpinnerWrapper>
          <Spinner $size={SIZE.small} />
        </SpinnerWrapper> : <>
          <div data-testid="frame-fetcher-container">
            <FrameFetcher setImageLoadedStatus={setImageLoadStatus} />
          </div>

          {annotationTimeline}
        </>}
    </Container>;
};